// added by evan@cooeecommerce.com

document.addEventListener("DOMContentLoaded", (event) => {

  // product page sticky bar
  if (document.body.classList.contains('template-product')) {
    window.onscroll = function() {stickyBar()};
    function stickyBar() {
      var sticky = document.querySelector(".product-sticky-section");
      if (document.documentElement.scrollTop > 250) {
        sticky.classList.add("product-sticky-section--stuck");
      } else {
        sticky.classList.remove("product-sticky-section--stuck");
      }
    };
  }

  // check current_variant.inventory_policy on product page load
  if (document.body.classList.contains('template-product')) {
    document.body.onload = function() {checkPolicy()};
    function checkPolicy() {
      if(invPolicy == "deny") {
        document.querySelector("#final-sale").style.display = "block";
        document.querySelector("#final-sale-property").value = "true";
      }
    };
  }

  // update values on variant change - product page sticky bar & custom inventory block
  document.addEventListener('variant:change', function(evt) {
    
    let hasVariant = evt.detail.variant;
    if (!hasVariant) {
      document.querySelector(".inventoryWrapper").innerHTML = "<p style='color: red;'>" + varUnavailable + "</p>";
    }
    
    var newVariant = evt.detail.variant.title;
    document.querySelector(".product-sticky-section__option").innerText = newVariant;
    var newPrice = evt.detail.variant.price;
    document.querySelector(".product-sticky-section__price").innerHTML = theme.Currency.formatMoney(newPrice, theme.settings.moneyFormat);
    var newQuantity = variantStock[evt.detail.variant.id];
    document.getElementsByName("properties[backorder]")[0].value = "";
    if (newQuantity < 1) {
  		document.querySelector(".inventoryWrapper").innerHTML = "<p style='color: red;'>" + backorderMessage + "</p>";
        document.querySelector("[data-add-to-cart-text]").innerText = backorderButton;
        document.getElementsByName("properties[backorder]")[0].value = "true";
  	} else if (newQuantity > 5) {
  		document.querySelector(".inventoryWrapper").innerHTML = "<p>" + inStockMessage + "</p>";
  	} else if (newQuantity == 1) {
  		document.querySelector(".inventoryWrapper").innerHTML = "<p>Only " + newQuantity + " item in stock!</p>";
  	} else {
  		document.querySelector(".inventoryWrapper").innerHTML = "<p>Only " + newQuantity + " items in stock!</p>";
  	};
    // check variant inventory_policy
    var newPolicy = variantPolicy[evt.detail.variant.id];
    if(newPolicy == "deny") {
        document.querySelector("#final-sale").style.display = "block";
        document.querySelector("#final-sale-property").value = "true";
    } else {
        document.querySelector("#final-sale").style.display = "none";
        document.querySelector("#final-sale-property").value = "false";
    };
  });

  // show/hide backorder terms checkbox on cart page/drawer if backorder product is added/removed
  document.addEventListener('cart:updated', function(evt) {
    let cartItems = evt.detail.cart.items;
    let x = 0;
    for (let i = 0; i < cartItems.length; i++) {
      let cartProperty = cartItems[i].properties;
      if (cartProperty.backorder == "true") {
        x++;
      }
    };
    //console.log(x);
    if (x > 0) {
      if (document.querySelector(".cart__terms.backorder.cart-page") !== null) {
        document.querySelector(".cart__terms.backorder.cart-page").style.display = "flex";
        document.getElementById("BackorderTerms").checked = false;
      }
      if (document.querySelector(".cart__terms.backorder.cart-drawer") !== null) {
        document.querySelector(".cart__terms.backorder.cart-drawer").style.display = "flex";
        document.getElementById("BackorderTermsDrawer").checked = false;
      }
    } else {
      if (document.querySelector(".cart__terms.backorder.cart-page") !== null) {
        document.querySelector(".cart__terms.backorder.cart-page").style.display = "none";
        document.getElementById("BackorderTerms").checked = true;
      }
      if (document.querySelector(".cart__terms.backorder.cart-drawer") !== null) {
        document.querySelector(".cart__terms.backorder.cart-drawer").style.display = "none";
        document.getElementById("BackorderTermsDrawer").checked = true;
      }
    }
  });

  // show backorder terms checkbox in cart drawer if backorder product is added
  document.addEventListener('ajaxProduct:added', function(evt) {
    //console.log(evt.detail.product);
    if (evt.detail.product.properties.backorder == "true") {
      document.querySelector(".cart__terms.backorder.cart-drawer").style.display = "flex";
      document.getElementById("BackorderTermsDrawer").checked = false;
    }
  });


  // -----------------------------------------
  // Define the parallax-banner custom element
  // -----------------------------------------
  
  class ParallaxBanner extends HTMLElement {
    constructor() {
      super();
      
      // Initialize properties
      this.parallaxSection = null;
      this.parallaxLayers = null;
      this.observer = null;
      this.ticking = false;
      
      // Bind methods to preserve context
      this.handleScroll = this.handleScroll.bind(this);
      this.init = this.init.bind(this);
      this.updateParallax = this.updateParallax.bind(this);
    }
    
    // Lifecycle callbacks
    connectedCallback() {
      this.init();
      this.setupIntersectionObserver();
      
      // Add initial update after DOM content is loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          requestAnimationFrame(() => {
            this.updateParallax();
          });
        });
      } else {
        // If DOM is already loaded, update immediately
        requestAnimationFrame(() => {
          this.updateParallax();
        });
      }
    }
    
    disconnectedCallback() {
      this.cleanup();
    }
    
    init() {
      try {
        this.parallaxSection = this.querySelector('.parallax-section');
        this.parallaxLayers = this.querySelectorAll('.parallax__layer--parallax');
        
        // if (!this.parallaxSection) {
        //   throw new Error('Parallax section not found');
        // }
        
        // if (!this.parallaxLayers.length) {
        //   throw new Error('No parallax layers found');
        // }
        
        // Set default values for layers without data attributes
        // this.parallaxLayers.forEach(layer => {
        //   if (!layer.dataset.speed) {
        //     layer.dataset.speed = '0.5';
        //   }
        //   if (!layer.dataset.direction) {
        //     layer.dataset.direction = 'translateY';
        //   }
        // });
        
      } catch (error) {
        console.error('ParallaxBanner initialization failed:', error);
        return;
      }
    }
    
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '50px',
        threshold: 0
      };
      
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', this.handleScroll, { passive: true });
            // Update parallax immediately when element comes into view
            requestAnimationFrame(() => {
              this.updateParallax();
            });
          } else {
            window.removeEventListener('scroll', this.handleScroll);
          }
        });
      }, options);
      
      this.observer.observe(this.parallaxSection);
    }
    
    handleScroll() {
      // Request animation frame for smooth performance
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.updateParallax();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }
    
    updateParallax() {
      try {
        const sectionHeight = this.parallaxSection.clientHeight;
        const sectionRect = this.parallaxSection.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        
        // Only update if section is in viewport
        if (sectionRect.top < viewportHeight && sectionRect.bottom > 0) {
          const distance = sectionRect.top - sectionHeight;
          
          this.parallaxLayers.forEach((layer) => {
            const img = layer.querySelector('img');
            if (!img) return;
            
            const { speed, direction } = layer.dataset;
            const transform = `${direction}(${distance * parseFloat(speed)}px)`;
            
            // Only update if transform changed
            if (img.style.transform !== transform) {
              img.style.transform = transform;
            }
          });
        }
      } catch (error) {
        console.error('Error updating parallax:', error);
      }
    }
    
    cleanup() {
      if (this.observer) {
        this.observer.disconnect();
      }
      window.removeEventListener('scroll', this.handleScroll);
    }
    
    // Static property for observing attributes
    static get observedAttributes() {
      return ['disabled'];
    }
    
    // Handle attribute changes
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'disabled') {
        if (newValue !== null) {
          this.cleanup();
        } else {
          this.init();
          this.setupIntersectionObserver();
          // Update parallax immediately when enabled
          requestAnimationFrame(() => {
            this.updateParallax();
          });
        }
      }
    }
  }
  
  // Register the custom element
  customElements.define('parallax-banner', ParallaxBanner);

});